<span id="createReverseAuditWizard_createFromFile">
  <app-spinner [isBusy]="showSpinner"></app-spinner>
  <h1>Step 1: Import Rate Audit File</h1>
  <div class="formContainer">
    <form id="userForm">
      <div class="k-widget k-upload k-header k-dropzone">
        <div role="button" class="cvt-primary k-button k-upload-button" aria-label="Select files..." tabindex="0">
          <input
            #fileItem="ngModel"
            autocomplete="off"
            type="file"
            id="asdffiles"
            name="asdffiles"
            accept="*/*"
            [(ngModel)]="myFiles"
            (change)="onFileSelected($event)" />
          <span>Select files...</span>
        </div>
        <ul class="k-upload-files k-reset" *ngIf="selectedFileToUpload">
          <li class="k-file k-file-success" tabindex="-1">

            <div class="k-file-single ng-tns-c13-0" >
              <span  class="k-progress ng-trigger ng-trigger-progressState" style="width: 100%; opacity: 0;"></span>
              <span class="k-file-extension-wrapper ng-tns-c13-0">
                <span class="k-file-extension">xls</span>
                <span class="k-file-state"></span>
              </span>
              <span class="k-file-name-size-wrapper ng-tns-c13-0">
                <span class="k-file-name" [title]="selectedFileToUpload" [innerText]="selectedFileToUpload"></span>
                <span class="k-file-size" [innerText]="uploadFilesize"></span>
              </span>

              <div class="ng-tns-c13-0">
                <strong class="k-upload-status">
                  <button type="button" class="k-button k-upload-action" tabindex="-1" (click)="onRemoveSelectedFile()">
                    <span class="k-icon k-delete k-i-x" aria-label="Remove" title="Remove">
                    </span>
                  </button>
                </strong>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </form>
    <div class="upload-stats">
      <app-alert></app-alert>
      <app-confirm-dialog [openModal]="showModal"></app-confirm-dialog>

      <div *ngIf="selectedFileToUpload"><div class="upload-stats-title">Total Property Count to be Audited: </div><span [innerText]="TotalPropertyCount"></span></div>
    </div>
  </div>
</span>
